import { toPayableAmount } from './toPayableAmount.helper';

type SortableRoom = {
  priority?: number | null;
  price?: { amount?: number | null } | null;
  discount?: { discountedPrice: { amount: number } } | null;
};

/**
 * Orders rooms by priority ascending (lower number shown first). Rooms without a priority
 * are placed after all prioritised rooms and, among themselves, ordered by the price the guest pays.
 */
export const byPriorityThenPrice = (a: SortableRoom, b: SortableRoom) => {
  const priorityA = a.priority ?? Infinity;
  const priorityB = b.priority ?? Infinity;
  if (priorityA !== priorityB) {
    return priorityA - priorityB;
  }
  return (
    (toPayableAmount(a.price, a.discount) ?? Infinity) -
    (toPayableAmount(b.price, b.discount) ?? Infinity)
  );
};
